import { AutoCompleteDesignTokens } from '@primeuix/themes/aura/autocomplete';

export const autoCompleteTokens: AutoCompleteDesignTokens = {
  root: {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    disabledColor: '{form.field.disabled.color}',
    filledBackground: '{form.field.filled.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    color: '{form.field.color}',
    placeholderColor: '{form.field.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    transitionDuration: '{transition.duration}',
    focusRing: {
      width: '{form.field.focus.ring.width}',
      style: '{form.field.focus.ring.style}',
      color: '{form.field.focus.ring.color}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
  },
  overlay: {
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.border.color}',
    borderRadius: '{overlay.select.border.radius}',
    color: '{overlay.select.color}',
    shadow: '{overlay.select.shadow}',
  },
  list: {
    padding: '{list.padding}',
    gap: '{list.gap}',
  },
  option: {
    focusBackground: '{list.option.focus.background}',
    focusColor: '{list.option.focus.color}',
    selectedBackground: '{list.option.selected.background}',
    selectedFocusBackground: '{list.option.selected.focus.background}',
    selectedFocusColor: '{list.option.selected.focus.color}',
    selectedColor: '{list.option.selected.color}',
    color: '{list.option.color}',
    padding: '{list.option.padding}',
    borderRadius: '{list.option.border.radius}',
  },
  optionGroup: {
    background: '{list.option.group.background}',
    color: '{list.option.group.color}',
    fontWeight: '{list.option.group.font.weight}',
    padding: '{list.option.group.padding}',
  },
  dropdown: {
    width: '2.5rem',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.border.color}',
    activeBorderColor: '{form.field.border.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    sm: {
      width: '2rem',
    },
    lg: {
      width: '3rem',
    },
  },
  chip: {
    borderRadius: '{border.radius.sm}',
  },
  emptyMessage: {
    padding: '{list.option.padding}',
  },
  colorScheme: {
    light: {
      dropdown: {
        background: '{surface.100}',
        hoverBackground: '{surface.200}',
        hoverColor: '{surface.700}',
        activeBackground: '{surface.300}',
        activeColor: '{surface.800}',
        color: '{surface.600}',
      },
      chip: {
        focusBackground: '{surface.200}',
        focusColor: '{surface.800}',
      },
    },
    dark: {
      dropdown: {
        background: '{primary.950}',
        hoverBackground: '{primary.900}',
        hoverColor: '{text.color}',
        activeBackground: '{primary.800}',
        activeColor: '{text.color}',
        color: '{text.color}',
      },
      chip: {
        focusBackground: '{primary.800}',
        focusColor: '{text.color}',
      },
    },
  },
};
